export * from "./inventory-debug.component";
